import { render, staticRenderFns } from "./PlaceShowView.vue?vue&type=template&id=236e4716&scoped=true&"
import script from "./PlaceShowView.vue?vue&type=script&lang=js&"
export * from "./PlaceShowView.vue?vue&type=script&lang=js&"
import style0 from "./PlaceShowView.vue?vue&type=style&index=0&id=236e4716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236e4716",
  null
  
)

export default component.exports